import { useFlags } from '../hooks';
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

export const MaintenanceWrapper = ({ children }): JSX.Element => {
  const history = useHistory();
  const { pathname } = useLocation();
  const { blMaintenanceMode } = useFlags();

  useEffect(() => {
    const isMaintenancePage = pathname.includes('/maintenance');
    const redirectToUrl = !isMaintenancePage ? encodeURIComponent(pathname) : undefined;

    if (blMaintenanceMode && redirectToUrl && !isMaintenancePage) {
      history.push(`/maintenance?redirect=${redirectToUrl}`);
    } else if (blMaintenanceMode && !isMaintenancePage) {
      history.push(`/maintenance`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blMaintenanceMode, pathname]);

  return children;
};
